export const initialState = {
  data: null,
  error: null,
}
